enum EasyStorePremission {
  Prem_Easy_Get_Employee = 'Prem_Easy_Get_Employee',
}

export default EasyStorePremission;
